import { customerConstants } from '../../_constants';

export function customers(state = {}, action) {
    switch (action.type) {
        case customerConstants.CUSTOMER_FETCHING:
            return {
                ...state,
                customerFetching: true
            };
        case customerConstants.CUSTOMER_FETCHED:
            return {
                ...state,
                customerFetching: false
            };
        case customerConstants.CUSTOMER_SUBMITTING:
            return {
                ...state,
                customerSubmitting: true
            };
        case customerConstants.CUSTOMER_SUBMITTED:
            return {
                ...state,
                customerSubmitting: false
            };
        case customerConstants.GET_ALL_CUSTOMERS:
            return {
                ...state,
                allCustomers: action.allCustomers
            };
        case customerConstants.GET_ACTIVE_CUSTOMERS:
            return {
                ...state,
                activeCustomers: action.activeCustomers
            };
        case customerConstants.GET_CUSTOMERS:
            return {
                ...state,
                customers: action.customers
            };
        case customerConstants.GET_CUSTOMER_BY_ID:
            return {
                ...state,
                customer: action.customer
            };
        case customerConstants.GET_SHIPPER_CONSIGNEE:
            return {
                ...state,
                ShipperConsignee: action.ShipperConsignee
            };
        case customerConstants.CLEAR_CUSTOMERS:
            return {}
        case customerConstants.CLEAR_GOODS:
            return {
                ...state,
                ShipperConsignee: []
            };
        case customerConstants.SEARCH_CUSTOMER:
            return {
                ...state,
                SearchCustomer: action.SearchCustomer
            };
        case customerConstants.GET_CUSTOMER_PAYOR:
            return {
                ...state,
                CustomerPayor: action.CustomerPayor
            };
        case customerConstants.SHIPPER_CONSIGNEE_GROUP:
            return {
                ...state,
                ShipperConsigneeWithGroup: action.ShipperConsigneeWithGroup
            };
        case customerConstants.CUSTOMER_RATES_COMMODITY:
            return {
                ...state,
                customerRateCommodity: action.customerRateCommodity
            };
        case customerConstants.CUSTOMER_PER_BAG:
            return {
                ...state,
                customerSQPerBag: action.customerSQPerBag
            };
        case customerConstants.GET_CUSTOMER_FROM_BASE:
                return {
                    ...state,
                    customerFromBASE: action.customerFromBASE
                };
        case customerConstants.GET_STRIPPING_STUFFING:
            return {
                ...state,
                StrippingStuffingCharge: action.StrippingStuffingCharge
            };
        case customerConstants.GET_COLLECTION_PAYOR:
            return {
                ...state,
                CollectionPayor: action.CollectionPayor
            };
        case customerConstants.GET_CUSTOMER_DETAILS:
            return {
                ...state,
                CustomerDetail: action.CustomerDetail
            };
        case customerConstants.SHIPPER_COMMODITY:
            return {
                ...state,
                shipperCommodity: action.shipperCommodity
            };
        case customerConstants.CUSTOMER_RATE_COMMODITY_CATEGORY:
            return {
                ...state,
                rateCommodityCategory: action.rateCommodityCategory
            };
        case customerConstants.COMPUTE_INSURANCE:
            return {
                ...state,
                comptInsurance: action.comptInsurance
            };
        case customerConstants.GET_AE_ID:
            return {
                ...state,
                AEId: action.AEId
            };
        default:
            return state;
    }
}